import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { NotifyOptionComponent } from './notify-option.component';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-lost-time-option',
  imports: [SelectOptionComponent, NotifyOptionComponent],
  template: `
    <app-select-option
      label="The lost time guidelines have reached"
      [control]="control"
      [optionValue]="null"
      [items]="alerts.percentRangeItems"
      [multiple]="false"
      [filter]="false"
      [virtualScroll]="false"
      selectLabel="Threshold"
    />
    <app-notify-option [control]="notifyControl" />
  `,
  styles: ``,
})
export class LostTimeOptionComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  control: FormControl<any>;

  @Input()
  notifyControl: FormControl<number>;

  async ngOnInit() {
    this.control.addValidators([Validators.required]);
    if (this.control.value == null) {
      this.control.setValue(this.alerts.find(this.alerts.percentRangeItems, 1));
    }
    this.control.updateValueAndValidity({ emitEvent: false });

    if (this.notifyControl.value == null) {
      this.notifyControl.setValue(1);
    }
    this.notifyControl.updateValueAndValidity({ emitEvent: false });
  }
}
